/**
 * #1555 coverage evidence for the Close/Update panel.
 *
 * `basis` is the server-built, non-commercial one-line explanation. `detail` is the verbatim contract/decision
 * note and is absent for roles that cannot see money. Keep the role boundary on the API; this component only makes
 * authorized detail deliberately expandable instead of dumping it into the form.
 */
import { coverageBasisText } from '../case-rail-context/coverage-basis'

export function CoverageBasisNote({ basis, detail }: { basis: string; detail?: string | null }) {
  const full = detail?.trim()
  const showDetail = Boolean(full && full !== basis.trim())

  return (
    <div className="min-w-0 space-y-1 text-xs font-normal text-muted-foreground">
      <p className="break-words">{coverageBasisText(basis)}</p>
      {showDetail ? (
        <details>
          <summary className="w-fit cursor-pointer underline underline-offset-2">Full coverage note</summary>
          <p className="mt-1 max-h-40 overflow-auto whitespace-pre-wrap break-words rounded bg-muted px-2 py-1.5 text-foreground">
            {coverageBasisText(full ?? '')}
          </p>
        </details>
      ) : null}
    </div>
  )
}

export function CoverageBasisDetail({ basis, detail }: { basis: string; detail?: string | null }) {
  const full = detail?.trim()
  if (!full || full === basis.trim()) return null
  return (
    <details className="min-w-0 text-xs text-muted-foreground sm:col-start-3">
      <summary className="w-fit cursor-pointer underline underline-offset-2">Full coverage note</summary>
      <p className="mt-1 max-h-40 overflow-auto whitespace-pre-wrap break-words rounded bg-muted px-2 py-1.5 text-foreground">
        {coverageBasisText(full)}
      </p>
    </details>
  )
}
